"use client";

import { useEffect } from "react";
import { toast } from "react-hot-toast";
import { useRouter } from "next/navigation";

interface NotificationData {
    title: string;
    message: string;
    type?: string;
    link?: string;
}

export function NotificationListener() {
    const router = useRouter();

    useEffect(() => {
        // 1. Get token from localStorage or cookie
        // Assuming we store it in localStorage "token" or "access_token"
        // Adjust based on actual auth implementation
        const token = typeof window !== "undefined" ? localStorage.getItem("token") || localStorage.getItem("accessToken") : null;

        if (!token) {
            console.warn("No auth token found, skipping notification stream connection.");
            return;
        }

        const url = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000"}/api/v1/notifications/stream?token=${token}`;

        // 2. Setup EventSource
        const eventSource = new EventSource(url);

        eventSource.onopen = () => {
            // console.log("Notification stream connected");
        };


        eventSource.onmessage = (event) => {
            try {
                // Check for initial connection message or keep-alive
                if (event.data === "connected") return;

                const data = JSON.parse(event.data) as NotificationData;

                // 3. Show Popup
                toast.custom((t) => (
                    <div 
                        className="flex flex-col gap-1 min-w-[200px] cursor-pointer"
                        onClick={() => {
                            if (data.link) {
                                try {
                                    // Handle full URL or relative path
                                    if (data.link.startsWith("http")) {
                                        const url = new URL(data.link);
                                        if (url.origin === window.location.origin) {
                                            router.push(url.pathname + url.search);
                                        } else {
                                            window.location.href = data.link;
                                        }
                                    } else {
                                        router.push(data.link);
                                    }
                                } catch (_e) {
                                    window.location.href = data.link;
                                }
                            }
                            toast.dismiss(t.id);
                        }}
                    >
                        <span className="font-bold text-sm">
                            {data.title || "Thông báo mới"}
                        </span>
                        <span className="text-sm text-gray-600">
                            {data.message}
                        </span>
                        {data.link && (
                            <span className="text-xs text-blue-600 mt-1">Xem chi tiết &rarr;</span>
                        )}
                    </div>
                ), {
                    position: "bottom-right",
                    duration: 5000,
                    style: {
                        border: '1px solid #E0E0E0',
                        padding: '16px',
                        color: '#333',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        borderRadius: '8px',
                    },
                    icon: '🔔',
                });

            } catch (e) {
                console.error("Failed to parse notification", e);
            }
        };

        eventSource.onerror = (e) => {
            console.error("Notification stream error", e);
            eventSource.close();
            // Retry logic could go here (e.g. setTimeout to reconnect)
        };

        return () => {
            eventSource.close();
        };
    }, []);

    return null;
}
